export const getCookies = () =>
  document.cookie
    .split(";")
    .filter(Boolean)
    .reduce((total, current) => {
      const [name, ...value] = current.split("=");
      total[name.trim()] = value.join("=").trim();
      return total;
    }, {});
